import ReactTooltip from "react-tooltip";
import { useParams, useHistory } from "react-router-dom";
import Table from "../../common/components/Table";
import ReactPaginate from "react-paginate";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import moment from "moment";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import { recommendationVideoTableData } from "../tableData";
import VideoDetailModal from "./VideoDetailModal";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import { findInfoPathFromBreadCrump, findPrevPathFromBreadCrumpData, popBreadCrumpOnPageClose } from "../../../config/utils";

const VideoTable = ({ isRecommendation, isModal, mobileRecommendationId, isMobileRegularRecom = false }) => {
    const [tableData, setTableData] = useState(recommendationVideoTableData);
    const [infoPage, setInfoPage] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const updateDataRef = useRef(null);
    const history = useHistory();

    const { mobileRecommendationVideoEntityParams, deleteAssetByIdVoiceNotesResponse, getMobileRecommendationVideosResponse } = useSelector(
        state => state.mobileRecommendationsReducer
    );

    const [paginationParams, setPaginationParams] = useState(mobileRecommendationVideoEntityParams?.paginationParams);
    const [params, setParams] = useState(mobileRecommendationVideoEntityParams?.params);
    const { id } = useParams();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            actions.getRecommendationVideos(isModal ? mobileRecommendationId : id, {
                page_type: isRecommendation ? "recommendations" : "asset",
                ...params
            })
        );
    }, [id, params?.limit, params?.offset]);

    useEffect(() => {
        if (deleteAssetByIdVoiceNotesResponse?.data.success && updateDataRef.current) {
            updateDataRef.current = false;
            setShowConfirmModal(false);
            setInfoPage(null);
            setDeleteItemId(null);
            dispatch(
                actions.getAssetVoiceNotes(isModal ? mobileRecommendationId : id, {
                    page_type: "asset",
                    ...params,
                    ...(isMobileRegularRecom ? { view_from: "recommendation" } : {})
                })
            );
        }
    }, [deleteAssetByIdVoiceNotesResponse]);

    useEffect(() => {
        if (getMobileRecommendationVideosResponse) {
            if (getMobileRecommendationVideosResponse?.success) {
                let tempList = getMobileRecommendationVideosResponse?.video ?? [];
                let totalCount = 0;
                totalCount = getMobileRecommendationVideosResponse ? getMobileRecommendationVideosResponse?.count || 0 : 0;

                tempList.forEach(temp => {
                    temp.updated_at = moment(temp.updated_at).format("MM-DD-YYYY h:mm A");
                    temp.created_at = moment(temp.created_at).format("MM-DD-YYYY h:mm A");
                });
                setTableData({ ...tableData, data: tempList });
                setPaginationParams({ ...paginationParams, totalCount, totalPages: Math.ceil(totalCount / paginationParams.perPage) });
            }
        }
    }, [getMobileRecommendationVideosResponse]);

    const handlePerPageChange = async e => {
        const newPerPage = e.target.value;

        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            perPage: newPerPage,
            currentPage: 0
        }));

        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            limit: newPerPage
        }));
    };

    const showInfoPage = (id, projectId, rowData) => {
        setInfoPage(rowData);
    };

    const deleteVoiceNotes = async () => {
        dispatch(actions.deleteVoiceNoteById(deleteItemId));
        updateDataRef.current = true;
    };

    const handleDeleteItem = id => {
        setDeleteItemId(id);
        setShowConfirmModal(true);
    };

    const renderConfirmationModal = () => {
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this Voice Notes?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => {
                            setShowConfirmModal(false);
                            setDeleteItemId(null);
                        }}
                        onYes={deleteVoiceNotes}
                    />
                }
                onCancel={() => setShowConfirmModal(false)}
            />
        );
    };

    return (
        <LoadingOverlay spinner={<Loader />} fadeSpeed={10} active={getMobileRecommendationVideosResponse?.isLoading}>
            {infoPage && <Portal body={<VideoDetailModal onClose={() => setInfoPage(null)} basicDetails={infoPage} />} />}
            <div className="tab-active recomdn-table bg-grey-table location-sec img-dt">
                {!isModal && (
                    <div className="otr-edit-delte col-md-12 text-right ed-dl">
                        <span
                            onClick={() => {
                                const currentBreadCrumbData = findInfoPathFromBreadCrump();
                                if (currentBreadCrumbData?.length && currentBreadCrumbData?.[currentBreadCrumbData?.length - 1]?.isFromTable) {
                                    popBreadCrumpOnPageClose();
                                }
                                popBreadCrumpOnPageClose();
                                history.push(findPrevPathFromBreadCrumpData());
                            }}
                            className="edit-icn-bx"
                        >
                            <i className="fas fa-window-close"></i> Close
                        </span>
                    </div>
                )}
                <div className="dtl-sec col-md-12">
                    <Table
                        tableData={tableData}
                        tableParams={{}}
                        hasDelete={false}
                        handleDeleteItem={handleDeleteItem}
                        showInfoPage={showInfoPage}
                        hasViewIcon={true}
                        updateSelectedRow={() => {}}
                        hasEdit={false}
                        disableRowClickBreadcrumb={isModal}
                    />
                    {tableData?.data && tableData?.data?.length ? (
                        <div className="table-bottom d-flex">
                            <div className="count d-flex col-md-6">
                                <div className="count-dtl">
                                    Total Count: <span>{paginationParams.totalCount}</span>
                                </div>
                                <div className="col-md-2 pr-2 selbx">
                                    <select className="form-control" value={paginationParams.perPage} onChange={e => handlePerPageChange(e)}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                    </select>
                                </div>
                            </div>
                            <div className="pagination-sec col-md-6">
                                <ReactPaginate
                                    previousLabel={
                                        <span data-place="top" data-effect="solid" data-tip={`Previous`} data-background-color="#007bff">
                                            &lt;
                                        </span>
                                    }
                                    nextLabel={
                                        <span data-place="top" data-effect="solid" data-tip={`Next`} data-background-color="#007bff">
                                            &gt;
                                        </span>
                                    }
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={1}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={() => {}}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    activeLinkClassName={"active"}
                                    forcePage={1}
                                />
                                <ReactTooltip />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            {renderConfirmationModal()}
        </LoadingOverlay>
    );
};

export default VideoTable;
